import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
// firebase
import { FirebaseTimestamp } from '../firebase'
// mui
import Divider from '@material-ui/core/Divider'

const dateToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) 
}

const NewsCard = props => {
    const dispatch = useDispatch()

    const postDate = props.date ? dateToString(props.date.toDate()) : ''
    const newIcon = (FirebaseTimestamp.now() - props.date < 60*60*24*10 ) ? 'new' : ''

    return (
        <>
        { (!props.isTrash && !props.isDraft) && (
            <MagazineCardWrapper>
                <FlexWrapper>
                    <div onClick={() => dispatch(push(`/news/dp/${props.id}`))}>
                        <Date>{postDate}</Date>
                        <New>{newIcon}</New>
                        <Title>{props.title}</Title>
                    </div>
                </FlexWrapper>

                <Divider />
            </MagazineCardWrapper>
        )}
        </>
    )
}

export default NewsCard

const MagazineCardWrapper = styled.div`
    width: 640px;
    padding: 10px;
    font-size: .9rem;
    cursor: pointer;
    @media screen and (max-width:768px){
        width: 100%;
        padding: 10px 20px;
    }
`
const Date = styled.span`
    width: 100px;
    font-weight: bold;
`
const New = styled.span`
    width: 100px;
    font-size: 1.15rem;
    color: #FCEB04;
    margin-left: 10px;
`
const Title = styled.div`
    width: 100%;
    line-height: 2.7rem;
    margin-bottom: .5rem;
    @media screen and (max-width:768px){
        line-height: 1.1rem;
        margin-top: .5rem;
        margin-bottom: 1.5rem;
    }
`
const FlexWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`